import "./style.css";

export const Footer = () => {
  return (
    <div className="sidebar-footer">
      <div className="sidebar-footer-company-info">
        <p>ООО «Айрин Секьюрити»</p>
        <p>ИНН 9714049463</p>
      </div>
      <div className="sidebar-footer-bottom-bar">
        <p>Copyright 2024. All Rights Reserved.</p>
      </div>
    </div>
  );
};
